export default __webpack_public_path__ + "07b31cceba6227bc28a14b55a587c042.png";